import { SideModal } from "components/ui";
import ModalHeading from "components/ui/Modal/ModalHeading/ModalHeading";
import NewUpdateForm from "./NewUpdateForm/NewUpdateForm";

const NewUpdateModal = ({
    showModal,
    closeModal,
    title,
    subTitle,
    handleSuccess,
    cannedResourceType,
    isEdit,
    selectedCannedUpdate,
}) => {
    return (
        <SideModal show={showModal} close={closeModal}>
            <div className='row me-0 ms-0'>
                <div className='col-10 offset-1'>
                    <ModalHeading title={title} subTitle={subTitle} />
                    <NewUpdateForm
                        closeModal={closeModal}
                        handleSuccess={handleSuccess}
                        cannedResourceType={cannedResourceType}
                        isEdit={isEdit}
                        selectedCannedUpdate={selectedCannedUpdate}
                    />
                </div>
            </div>
        </SideModal>
    );
};

export default NewUpdateModal;
